// aliases: the environments this instance manages, and the names people commonly use
// for it. aliasNote qualifies that list where it applies to every region.
export const INSTANCES = [
  {
    id: "repstor",
    label: "Repstor Prod",
    subscription: "Repstor",
    env: "prod",
    url: "https://management.repstor.com",
    hostname: "management.repstor.com",
    aliases: ["Preview", "Custodian01"],
    aliasNote: null,
  },
  {
    id: "intapp-nonprod",
    label: "Intapp Test",
    subscription: "Intapp",
    env: "nonprod",
    url: "https://collaboration-management.play.intapp.com",
    hostname: "collaboration-management.play.intapp.com",
    aliases: ["Dev1", "Qa1"],
    aliasNote: "all regions",
  },
  {
    id: "intapp-prod",
    label: "Intapp Prod",
    subscription: "Intapp",
    env: "prod",
    url: "https://collaboration-management.think.intapp.com",
    hostname: "collaboration-management.think.intapp.com",
    aliases: ["Sand", "Prod"],
    aliasNote: "all regions",
  },
];

export const UNKNOWN_INSTANCE = {
  id: "unknown",
  label: "Local / Unknown",
  subscription: null,
  env: "unknown",
  url: null,
  hostname: null,
  aliases: [],
  aliasNote: null,
};

export function getCurrentInstance() {
  const host = window.location.hostname;
  return INSTANCES.find((instance) => instance.hostname === host) ?? UNKNOWN_INSTANCE;
}
